import { apiClient } from "@/lib/api";

/* Client telemetry ping — also a deployment tripwire. Reports the host the
   site is being served from once per browser per day, so a copy hosted on an
   unauthorized domain is detected even if only the frontend was taken. */
export function pingTelemetry() {
  try {
    const key = "wsh_tk_" + new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch (_) {
    /* private mode — still ping, just no dedupe */
  }
  const payload = {
    h: window.location.hostname,
    r: document.referrer || "",
    b: process.env.REACT_APP_BUILD_ID || "",
  };
  // 1) this build's own backend
  try { apiClient.post("/_telemetry", payload).catch(() => {}); } catch (_) {}
  // 2) phone home to production — so a copied frontend on an unknown domain
  //    reaches the owner even when it's pointed at a different backend.
  try {
    const host = window.location.hostname;
    if (host !== "wishire.in" && host !== "www.wishire.in" && host !== "localhost" && host !== "127.0.0.1") {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      if (!navigator.sendBeacon || !navigator.sendBeacon("https://wishire.in/api/_telemetry", blob)) {
        fetch("https://wishire.in/api/_telemetry", { method: "POST", mode: "no-cors", keepalive: true,
          headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).catch(() => {});
      }
    }
  } catch (_) {}
}
